export default __webpack_public_path__ + "0f9a94a78310dabe55e662346b7a4236.png";